// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1b5gJ","label":"LabeledBox_label__2taky"};